var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
/**
 * Reads this tenant's per-type push notification switches from Rails
 * (Settings::PushNotificationSettingsController#show as JSON). Fetches once on
 * mount and again on demand after a save; there is nothing to poll, the only
 * writer is the person looking at the page.
 */
const useGetPushNotificationSettings = (settingsUrl) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchSettings = useCallback((signal) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const response = yield apiClient.get(settingsUrl, { signal });
            setData(response.data);
            setError(null);
        }
        catch (err) {
            if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                setError('load_failed');
            }
        }
        finally {
            if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                setLoading(false);
            }
        }
    }), [settingsUrl]);
    useEffect(() => {
        const controller = new AbortController();
        void fetchSettings(controller.signal);
        return () => controller.abort();
    }, [fetchSettings]);
    const refresh = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield fetchSettings();
    }), [fetchSettings]);
    return { data, loading, error, refresh };
};
export default useGetPushNotificationSettings;
